import script from "./SpecialtyTableRow.vue?vue&type=script&lang=ts&setup=true"
export * from "./SpecialtyTableRow.vue?vue&type=script&lang=ts&setup=true"

import "./SpecialtyTableRow.vue?vue&type=style&index=0&id=74bcae46&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74bcae46"]])

export default __exports__